/* eslint-disable max-len */
import React from 'react';
function PerformancePosition() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM15 9C15 10.65 13.65 12 12 12C10.35 12 9 10.65 9 9C9 7.35 10.35 6 12 6C13.65 6 15 7.35 15 9ZM13 9C13 8.45 12.55 8 12 8C11.45 8 11 8.45 11 9C11 9.55 11.45 10 12 10C12.55 10 13 9.55 13 9ZM18 16.58C18 14.08 14.03 13 12 13C9.97 13 6 14.08 6 16.58V18H18V16.58ZM12 15C10.71 15 9.22 15.49 8.48 16H15.52C14.78 15.49 13.29 15 12 15ZM5 19H19V5H5V19Z" })));
}
export default PerformancePosition;
